<template>
  <div>
    <pdl-callout v-if="showErrorCallout" kind="error" qaid="product-feedback__global-errors">
      <template #content>
        <span v-html="bp('formGlobalError')" />
      </template>
    </pdl-callout>
    <section-header size="xl" variants="dividing">
      <heading level="1" size="xl" qaid="product-feedback__header" v-html="bp('submitProduct')" />
    </section-header>

    <section class="mt-5">
      <!-- Header -->
      <section-header size="md" variants="dividing">
        <heading level="3" size="md" qaid="product-feedback__contact-info-header" v-html="bp('feedbackContact')" />
      </section-header>

      <!-- Contact Info -->
      <div class="grid-x grid-margin-x">
        <div class="cell medium-4">
          <form-group
            v-model="feedbackData.contactName"
            v-validate="'required'"
            type="text"
            name="contactName"
            qaid="product-feedback__contact-person"
            :error="errors.first('contactName')"
            :show-error-messages="true"
            :data-vv-as="bp('contactPerson')"
            :label="bp('contactPerson')"
            :required="true"
            :value="feedbackData.contactName"
          />
        </div>
        <div class="cell medium-4">
          <form-group
            v-model="feedbackData.contactPhoneNumber"
            type="text"
            name="contactPhoneNumber"
            qaid="product-feedback__contact-phone"
            :maxlength="26"
            :error="errors.first('contactPhoneNumber')"
            :show-error-messages="true"
            :data-vv-as="bp('phone')"
            :label="bp('phone')"
            :value="feedbackData.contactPhoneNumber"
          />
        </div>
        <div class="cell medium-4">
          <form-group
            v-model="feedbackData.contactEmail"
            v-validate="'required'"
            type="text"
            name="contactEmail"
            qaid="product-feedback__contact-email"
            :error="errors.first('contactEmail')"
            :show-error-messages="true"
            :data-vv-as="bp('email')"
            :label="bp('email')"
            :required="true"
            :value="feedbackData.contactEmail"
          />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import {PdlCallout} from '@pedal/pdl-callout';
import FormGroup from '@/components/FormGroup';
import SectionHeader from '@/components/SectionHeader';

export default {
  inject: ['$validator'],
  components: {PdlCallout, FormGroup, SectionHeader},
  props: {
    baseProperties: {
      type: Array,
      default: () => [],
    },
    feedbackData: {
      type: Object,
      default: () => ({}),
    },
    showSuccess: Boolean,
  },
  computed: {
    showErrorCallout() {
      return this.$validator.errors.items.length;
    },
  },
  methods: {
    ...mapActions('productFeedback', ['updateFeedbackProperty', 'updateUserData']),
  },
};
</script>
